/* @flow */
import produce from 'immer'

export default function reducer(state, action: any) {
  const initialState = action.__initialData.defaultProps
  return produce(state, draft => {
    switch (action.type) {
      case 'CHANGE_TITLE':
        draft.title = action.value
        break
      case 'CHANGE_PARAGRAPH':
        draft.paragraph = action.value
        break
      case 'CHANGE_BUTTON_TEXT':
        draft.buttonText = action.value
        break
      case 'CHANGE_PHONE':
        draft.phone = action.value
        break
      case 'CHANGE_EMAIL':
        draft.email = action.value
        break
      case 'CHANGE_SOCIAL_TITLE':
        draft.socialTitle = action.value
        break
      case 'CHANGE_PLACEHOLDER_TEXT':
        const { key, value } = action.value
        if (draft.placeholders) {
          draft.placeholders[key] = value
        } else {
          draft.placeholders = { [key]: value }
        }
        break
      case 'ADD_SOCIAL':
        draft.socials.push(initialState.socials[0])
        break
      case 'REMOVE_SOCIAL':
        const { idx: socialIdx } = action.value
        draft.socials.splice(socialIdx, 1)
        break
      case 'CHANGE_SOCIAL_URL':
        const { idx, link } = action.value
        draft.socials[idx].socialUrl = link
        break
      case 'CHANGE_SOCIAL_ICON': {
        const { idx: idx, iconName } = action.value
        draft.socials[idx].icon = iconName
        break
      }
      case 'ADD_FORM':
        draft.buttonText = initialState.buttonText
        break
      case 'REMOVE_FORM':
        draft.buttonText = ''
        break
      case 'REMOVE_PHONE':
        draft.phone = ''
        break
      case 'ADD_PHONE':
        draft.phone = initialState.phone
        break
      case 'REMOVE_EMAIL':
        draft.email = ''
        break
      case 'ADD_EMAIL':
        draft.email = initialState.email
        break
      case 'CHANGE_TITLE_ALIGNMENT':
        draft.titleAlignment = action.value
        break
      case 'CHANGE_PARAGRAPH_ALIGNMENT':
        draft.paragraphAlignment = action.value
        break
      case 'CHANGE_CONTACT_ALIGNMENT': {
        const { alignment, alignmentKey } = action.value
        draft[alignmentKey] = alignment
        break
      }
    }
  })
}
